import { OktaAuth, toRelativeUrl } from "@okta/okta-auth-js";
import { LoginCallback, SecureRoute, Security } from "@okta/okta-react";
import Sso from "components/Sso/Sso";
import { config } from "config";
import ContentWrapper from "pages/ContentWrapper/ContentWrapper";
import React from "react";
import { Route, Switch, useHistory } from "react-router-dom";
import { Login } from "./pages/Login/Login";

const oktaAuth = new OktaAuth(config.oktaAuthOptions);

export default function App() {
    const history = useHistory();

    const restoreOriginalUri = async (oktaAuth: OktaAuth, originalUri: string) => {
        history.replace(toRelativeUrl(originalUri || "/", window.location.origin));
    };

    const customAuthHandler = () => {
        history.push("/login");
    };

    return (
        <Security oktaAuth={oktaAuth} onAuthRequired={customAuthHandler} restoreOriginalUri={restoreOriginalUri}>
            <Switch>
                <Route path="/login/callback">
                    <LoginCallback />
                </Route>
                <Route path="/login">
                    <Login />
                </Route>
                <Route path="/sso">
                    <Sso />
                </Route>
                <SecureRoute path="/">
                    <ContentWrapper />
                </SecureRoute>
            </Switch>
        </Security>
    );
}
